import { inject, Pipe, PipeTransform } from '@angular/core';

import { checkRecourseApproveRights } from '../services/booking/recourse-booking-functions';
import { UserService } from '../services/user-service/user.service';

@Pipe({
  name: 'canUserApproveAutomatedRecourseBookings',
})
export class AutomatedRecourseBookingsApprovalPipe implements PipeTransform {
  private readonly userService = inject(UserService);

  public transform(recourseBookingsToApprove: number): boolean {
    return checkRecourseApproveRights(this.userService.getRights()) && recourseBookingsToApprove > 0;
  }
}
